import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Stack from "@/pages/Stack";

export const Route = createFileRoute("/stack/")({
  head: () => seoHead("/stack/"),
  component: Stack,
});
